
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, ConstantService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { UserTitles } from '@app/_helpers/constants';
import {Contact, ContactService} from '@app/_components/contact';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ContactComponent implements OnInit {
	contactsList: any;
	isDisplayOwnerProfile : boolean = true;
	titles !: any;
	countries: any;
	states: any;
	assignedToUserId;


	constructor(
		private constantService: ConstantService,
		private primengConfig: PrimeNGConfig,
		private contactService: ContactService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.isDisplayOwnerProfile = data.isDisplayOwnerProfile == false ? false : true,
			this.contact = data.contact,
			this.statuses = contactService.statuses;
			this.ownersList = contactService.ownersList;
			this.titles = UserTitles;
			this.countries = this.constantService.countries;
			this.states = this.constantService.states;
	}

	@Input() contact: Contact;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();
	@Output() doClose = new EventEmitter<any>();

	// data
	contactId: number;
	contactObj : Contact[] =[];

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;
	ownersList: any;

	validationMessages = {
		'contactId': [],
		'firstName': [],
		'lastName': [],
		'suffix': [],
		'title': [],
		'emailAddress': [{ type: 'required', message: 'Required' },
      { type: 'email', message: 'Not a valid Email' }],
		'mobilePhone': [],
		'careOf': [],
		phone2: [],
		referralSrc: [],
		referralSrcId: [],
		vendorSrcId: [],
		fullName: [],
		subjAdrDevelopmentName: [],
		subjAdrStreet: [],
		subjAdrUnit: [],
		subjAdrStreet2: [],
		subjAdrCity: [],
		subjAdrState: [],
		subjAdrPostalCode: [],
		subjAdrCountry: [],
		mailAdrCompanyName: [],
		mailAdrStreet: [],
		mailAdrStreet2: [],
		mailAdrCity: [],
		mailAdrState: [],
		mailAdrPostalCode: [],
		mailAdrCountry: [],
		mailAdrPhone: [],
		mailAdrFax: [],
		opsNotes: []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole contact object
		if (this.contact) {
			this.contactId = this.contact.contactId;
			this.fixDates();
			this.form1.patchValue(this.contact);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.contactId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.contactService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.contact = res.data.contact;
						this.doAdd.emit(this.contact);
					},
					(err: any) => {
						console.log('contact-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('contact: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			this.form1.value.contactId = this.contactId;
			this.contactService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.contact = res.data.contact;
						this.doUpdate.emit(this.contact);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	setAssignedToUserId($event)
	{
		console.log($event);
		this.assignedToUserId = $event['assignedToUserId'];
	}

	formDelete() {
		try {
			this.contactService.delete(this.contact.contactId)
				.subscribe(
					(res: any) => {
						console.log('contact-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.contact);
					},
					(err: any) => {
						console.log('contact-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			contactId: [this.contactId],
			firstName: [],
			lastName: [],
			suffix: [],
			title: [],
			emailAddress: [null, Validators.compose([Validators.required, Validators.email])],
			mobilePhone: [],
			phone2: [],
			referralSrc: [],
			referralSrcId: [],
			subjAdrUnit: [],
			fullName: [],
			subjAdrDevelopmentName: [],
			subjAdrStreet: [],
			subjAdrStreet2: [],
			subjAdrCity: [],
			subjAdrState: [],
			subjAdrPostalCode: [],
			subjAdrCountry: ['US'],
			mailAdrCompanyName: [],
			mailAdrStreet: [],
			mailAdrStreet2: [],
			mailAdrCity: [],
			mailAdrState: [],
			mailAdrPostalCode: [],
			mailAdrCountry: [],
			mailAdrPhone: [],
			mailAdrFax: [],
			opsNotes: []
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.contact.contactDate = moment(this.contact.contactDate).toDate();
	}

	formAddPropertyLead() {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: "Add Owner Lead Profile",
			isDisplayPropertyProfile : true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(
			ContactComponent,
			dialogConfig
		);

		dialogRef.componentInstance.doAdd.subscribe((data) => {
			console.log("Dialog output:", data);

			this.contactsList = [];
			if(this.contact){
				this.contact?.contactVOList.unshift(data);

				// no idea what this is but it is required to update the array
				this.contact.contactVOList = [...this.contact?.contactVOList];
				this.form1.patchValue({
						 contactVOList : this.contact?.contactVOList
					 });

			 }
		 	else{

				console.log("DATA :: "+data);
				this.contactObj.push(data);
				console.log("contactObj :: "+JSON.stringify(this.contactObj));

				 this.form1.patchValue({
				 	contactVOList : this.contactObj
				 });
			 }
			 // close the dialogBox
			dialogRef.close();

		});
	}
}
